import lruCache from '@/utils/lru-object-cache';
import { ISrcset } from '@/components/Srcset/ISrcset';
import urlsService, { Target } from '@/services/urls-service';

export interface ITemplateData {
  customerRatings: ITemplateDataCustomerRatings;
  sector: ITemplateDataSector;
  sectorNavigation: SectorNavigationDataItem[];
  serviceNavigation: ILinkList;
  socialLinks: ILinkList;
  usps: ILinkList;
  footer: ITemplateDataFooter;
}

export interface ITemplateDataCustomerRatings {
  feedAvailable: boolean;
  text: string;
  score: string;
  reviewCount: number;
  icon: ApiImage;
  link: ApiLink;
}

export interface ITemplateDataFooter {
  locationContact: string;
  footer: ILinkList;
  actueel: ILinkList;
  overOns: ILinkList;
  klantenService: ILinkList;
}

export interface ITemplateDataSector {
  phone: string;
  email: string;
  navigation: ILinkList;
  logo: string;
}

export interface ILinkList {
  title: string;
  items: ApiLink[];
}

export interface SectorNavigationDataItem {
  key: string;
  name: string;
  image: ISrcset;
  link: string;
}

export class TemplateDataService {
  templateData!: ITemplateData;

  setTemplateData(templateData: ITemplateData) {
    this.templateData = templateData;
  }

  getTemplateData(): ITemplateData | null {
    return this.templateData || null;
  }

  isInitialized(): boolean {
    return !!this.templateData;
  }

  async fetchTemplateData(sector: AppSector): Promise<ITemplateData> {
    try {
      const url = urlsService.getUrl(`/clapi/template?sector=${sector}`, { target: Target.Sitecore });
      const cachedData = lruCache.get(url) as ITemplateData;

      if (cachedData) {
        this.templateData = cachedData;
        return this.templateData;
      }

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      this.templateData = await response.json();
      lruCache.set(url, this.templateData);

      return this.templateData;
    } catch (error) {
      console.error('Error fetching template data:', error);
      throw error;
    }
  }
}

const instance = new TemplateDataService();
export default instance;
